import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { ClickTracker } from 'bernie-analytics';

import { UitkLink } from 'uitk-react-link';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

import { CurrentHotelStore } from 'stores/current-hotel-store';
import { UserReviewViewModel } from 'models/hotel/review-types';

export interface ReviewHelpfulVoteProps {
  review: UserReviewViewModel;
  currentHotel?: CurrentHotelStore;
}

@inject('currentHotel')
@observer
export class ReviewHelpfulVote extends React.Component<ReviewHelpfulVoteProps> {
  constructor(props) {
    super(props);
    this.upvoteTotalThanks = this.upvoteTotalThanks.bind(this);
  }

  public upvoteTotalThanks() {
    const { currentHotel, review } = this.props;
    if (currentHotel && typeof currentHotel.upvoteReviewTotalThanks === 'function') {
      currentHotel.upvoteReviewTotalThanks(review.reviewId);
    }
  }

  public render() {
    const { currentHotel, review } = this.props;

    const LinkButtonTracked = ClickTracker(UitkLink);
    const upvoteDisabled = currentHotel && currentHotel.reviewIdsUpvoted && currentHotel.reviewIdsUpvoted.includes(review.reviewId);

    return (
      <div className="uitk-grid">
        <span className="uitk-cell all-cell-1-1 uitk-type-left all-cell-shrink">
          <LinkButtonTracked
            className="all-x-gutter-two all-t-margin-two all-cell-shrink"
            disabled={upvoteDisabled}
            linkName="upvote a review"
            rfrr="REVIEW.THUMB_UP.UPVOTE"
            theme="primary"
            onClick={this.upvoteTotalThanks}
          >
            <button>
              <UitkIcon name="thumb_up" size={UitkIconSize.SMALL} className="uitk-cell all-cell-shrink" />
              <span className="uitk-type-200 all-l-padding-one">{review && review.totalThanks}</span>
            </button>
          </LinkButtonTracked>
        </span>
      </div>
    );
  }
}
